// extracted by mini-css-extract-plugin
export default {"mainheader":"style_mainheader__HMUzG","currency-balance":"style_currency-balance__8P-1s"};